import { Component, OnInit, Optional, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { RepresentantsAOC } from 'src/app/core/entities/representantsaoc.model';
import { AuxiliarAOC } from 'src/app/core/entities/auxiliaraoc.model';
import { DialogsAlertComponent } from '../dialogs-alert/dialogs-alert.component';
import { DialogsRepresentantAOCService } from './dialogs-representant-aoc.service';
import { ValidService } from 'src/app/container/external/valid/valid.service';
import { Utils } from 'src/app/core/utils/utils';
import { EXTERNAL_ROL } from 'src/app/core/utils/constants';
import { SelectItem } from 'primeng/api';
import { Subscription } from 'rxjs';
import * as _ from 'lodash';

@Component({
  selector: 'app-dialogs-representant-aoc',
  templateUrl: './dialogs-representant-aoc.component.html',
  styleUrls: ['./dialogs-representant-aoc.component.css']
})
export class DialogsRepresentantAocComponent implements OnInit {

  $mostrar!: Subscription;
  loading: boolean = true;

  nifcheck1: string = "";
  carpeta: string = "";
  titulo: string = "";
  cheklogin: number = 1;
  llamada: number = 0;
  estadocombo: boolean = true;

  comprobarPerfilcheck1: boolean = false;
  comprobarPerfilcheck2: boolean = false;

  textoavisoperfil : string = "";
  textobotonperfil : string = "";

  representant: RepresentantsAOC = new RepresentantsAOC();
  allRepresentants: RepresentantsAOC[] = [];
  allRepresentantsPerfil: RepresentantsAOC[] = [];

  optionsRepresentant: SelectItem[] = [];
  optionsRepresentantBase: SelectItem[] = [];

  constructor(@Optional() @Inject(MAT_DIALOG_DATA) public data: any,
              @Optional() private dialogRef: MatDialogRef<DialogsRepresentantAocComponent>,
              private dialogsRepreAOCService: DialogsRepresentantAOCService,
              private translateService: TranslateService,
              private validService: ValidService,
              private dialog: MatDialog,
              public router: Router) { }

  ngOnInit(){

    this.comprobarPerfilcheck1 = false;
    this.comprobarPerfilcheck2 = false;
    this.estadocombo = true;
    this.optionsRepresentantBase.push({ value: null, label: "" });
    this.allRepresentants = _.cloneDeep(this.data.representant);
    this.llamada = _.cloneDeep(this.data.llamada);
    this.carpeta = _.cloneDeep(this.data.carpeta);
    this.nifcheck1 = _.cloneDeep(this.data.dni);

    switch(this.carpeta) {
      case "1": {
        this.titulo = this.translateService.instant('CIUDADANO.ACCESO.acceder');
        break;
      }
      case "2": {
        this.titulo = this.translateService.instant('EMPRESA.ACCESO.acceder');
        break;
      }
      case "3": {
        this.titulo = this.translateService.instant('PROVEEDOR.ACCESO.acceder');
        break;
      }
    }

    for (let i = 0; i < this.allRepresentants.length; i++) {
      if(this.allRepresentants[i].poderdantcognoms === null){
        this.optionsRepresentantBase.push({ value: this.allRepresentants[i].identificadorlegal, label: this.allRepresentants[i].poderdantnomraosocial });
      }else{
        this.optionsRepresentantBase.push({ value: this.allRepresentants[i].identificadorlegal, label: this.allRepresentants[i].poderdantnomraosocial + " " + this.allRepresentants[i].poderdantcognoms });
      }
    }

    this.optionsRepresentant = this.optionsRepresentantBase;
    this.optionsRepresentantBase = [];

    this.loading = false;
  }

  /**
  * @description
  * Al pulsar uno de los representados mostramos los datos del representado
  * @param valor representado seleccionado en el combo
  */
  valorerPulsado(valor: any){
    this.representant =  new RepresentantsAOC();
    for (let i = 0; i < this.allRepresentants.length; i++) {
      if(valor === this.allRepresentants[i].identificadorlegal){
        this.representant = _.cloneDeep(this.allRepresentants[i]);
      }
    }
  }

  /**
  * @description
  * Cierra el dialog y pasa el codigo de la entidad.
  */
  aceptar() {
    this.loading = true;
    if(this.cheklogin == 2){
      this.dialogsRepreAOCService.comprobarAOC(this.representant, this.carpeta).subscribe(result => {
        if(result === false){
          this.loading = false;
          this.errorWebservice('WARNINGS.error_aoc');
          switch(this.carpeta) {
            case "1": {
              this.router.navigate(["/external/passarela/acces"]);
              break;
            }
            case "2": {
              this.router.navigate(['/external/empreses/acces']);
              break;
            }
            case "3": {
              this.router.navigate(['/external/proveidors/acces']);
              break;
            }
          }
        }else{

          console.log("comprobacion OAC correcta");

          switch(this.carpeta) {
            case "1": {
              this.comprobarPerfilcheck1 = false;
              this.comprobarPerfilcheck2 = false;
              if(this.dialogsRepreAOCService.isCif){
                this.loading = false;
                let textoaviso = this.translateService.instant('WARNINGS.error_buscador_ciu');
                this.textobotonperfil = this.translateService.instant('EMPRESA.ACCESO.title');
                this.textoavisoperfil = textoaviso + this.dialogsRepreAOCService.nif.bold();
                this.comprobarPerfilcheck2 = true;
              }else{
                if(this.dialogsRepreAOCService.allPersons == null){
                  this.loading = false;
                  this.errorBuscaCiudadano();
                }else{
                  let auxilarAOC = new AuxiliarAOC();
                  auxilarAOC.identificador = _.cloneDeep(this.representant.identificadorlegal);
                  auxilarAOC.check = _.cloneDeep(this.cheklogin);
                  auxilarAOC.dboid = _.cloneDeep(this.dialogsRepreAOCService.dboidRepresentado);
                  auxilarAOC.llamada = _.cloneDeep(this.llamada);
                  this.dialogRef.close(auxilarAOC);
                  this.loading = false;
                }
              }
              break;
            }
            case "2": {
              this.comprobarPerfilcheck1 = false;
              this.comprobarPerfilcheck2 = false;
              if(this.dialogsRepreAOCService.isCif || this.dialogsRepreAOCService.isLicencias){
                if(this.dialogsRepreAOCService.allPersons == null){
                  this.loading = false;
                  this.errorBuscaEmpresa();
                }else{
                  let auxilarAOC = new AuxiliarAOC();
                  auxilarAOC.identificador = _.cloneDeep(this.representant.identificadorlegal);
                  auxilarAOC.check = _.cloneDeep(this.cheklogin);
                  auxilarAOC.dboid = _.cloneDeep(this.dialogsRepreAOCService.dboidRepresentado);
                  auxilarAOC.llamada = _.cloneDeep(this.llamada);
                  this.dialogRef.close(auxilarAOC);
                  this.loading = false;
                }
              }else{
                this.loading = false;
                let textoaviso = this.translateService.instant('WARNINGS.error_buscador_emp');
                this.textobotonperfil = this.translateService.instant('CIUDADANO.ACCESO.title');
                this.textoavisoperfil = textoaviso + this.dialogsRepreAOCService.nif.bold();
                this.comprobarPerfilcheck2 = true;
              }
              break;
            }
            case "3": {
              this.comprobarPerfilcheck1 = false;
              this.comprobarPerfilcheck2 = false;
              if(this.dialogsRepreAOCService.isProveidor.isproveedor){
                if(this.dialogsRepreAOCService.allPersons == null){
                  this.loading = false;
                  this.errorBuscaProveedor();
                }else{
                  let auxilarAOC = new AuxiliarAOC();
                  auxilarAOC.identificador = _.cloneDeep(this.representant.identificadorlegal);
                  auxilarAOC.check = _.cloneDeep(this.cheklogin);
                  auxilarAOC.dboid = _.cloneDeep(this.dialogsRepreAOCService.dboidRepresentado);
                  auxilarAOC.llamada = _.cloneDeep(this.llamada);
                  this.dialogRef.close(auxilarAOC);
                  this.loading = false;
                }
              }else{
                this.loading = false;
                if(this.dialogsRepreAOCService.isProveidor.error != null){
                  this.validService.errorCargaWS('WARNINGS.error_ws_provee');
                }else{
                  let textoaviso = this.translateService.instant('WARNINGS.error_buscador_prov');
                  this.textobotonperfil = this.translateService.instant('salir');
                  this.textoavisoperfil = textoaviso + this.dialogsRepreAOCService.nif.bold();
                  this.comprobarPerfilcheck2 = true;
                }
              }
              break;
            }
          }
        }
      });
    }else {
      this.dialogsRepreAOCService.comprobarMyCarpeta(this.nifcheck1, this.carpeta).subscribe(result => {
        switch(this.carpeta) {
          case "1": {
            this.comprobarPerfilcheck1 = false;
            this.comprobarPerfilcheck2 = false;
            if(this.dialogsRepreAOCService.isCif){
              this.loading = false;
              let textoaviso = this.translateService.instant('WARNINGS.error_buscador_ciu');
              this.textobotonperfil = this.translateService.instant('EMPRESA.ACCESO.title');
              this.textoavisoperfil = textoaviso + this.nifcheck1.bold();
              this.comprobarPerfilcheck1 = true;
            }else{
              if(this.dialogsRepreAOCService.allPersons == null){
                this.loading = false;
                this.errorBuscaCiudadano();
              }else{
                let auxilarAOC = new AuxiliarAOC();
                if(this.llamada == 1){
                  auxilarAOC.identificador = _.cloneDeep(this.representant.identificadorlegal);
                }else{
                  auxilarAOC.identificador = _.cloneDeep(null);
                  auxilarAOC.dboid = _.cloneDeep(null);
                }
                auxilarAOC.check = _.cloneDeep(this.cheklogin);
                auxilarAOC.llamada = _.cloneDeep(this.llamada);
                this.dialogRef.close(auxilarAOC);
                this.loading = false;
              }
            }
            break;
          }
          case "2": {
            this.comprobarPerfilcheck1 = false;
            this.comprobarPerfilcheck2 = false;
            if(this.dialogsRepreAOCService.isCif || this.dialogsRepreAOCService.isLicencias){
              if(this.dialogsRepreAOCService.allPersons == null){
                this.loading = false;
                this.errorBuscaEmpresa();
              }else{
                let auxilarAOC = new AuxiliarAOC();
                if(this.llamada == 1){
                  auxilarAOC.identificador = _.cloneDeep(this.representant.identificadorlegal);
                }else{
                  auxilarAOC.identificador = _.cloneDeep(null);
                  auxilarAOC.dboid = _.cloneDeep(null);
                }
                auxilarAOC.check = _.cloneDeep(this.cheklogin);
                auxilarAOC.llamada = _.cloneDeep(this.llamada);
                this.dialogRef.close(auxilarAOC);
                this.loading = false;
              }
            }else{
              this.loading = false;
              let textoaviso = this.translateService.instant('WARNINGS.error_buscador_emp');
              this.textobotonperfil = this.translateService.instant('CIUDADANO.ACCESO.title');
              this.textoavisoperfil = textoaviso + this.nifcheck1.bold();
              this.comprobarPerfilcheck1 = true;
            }
            break;
          }
          case "3": {
            this.comprobarPerfilcheck1 = false;
            this.comprobarPerfilcheck2 = false;
            if(this.dialogsRepreAOCService.isProveidor.isproveedor){
              if(this.dialogsRepreAOCService.allPersons == null){
                this.loading = false;
                this.errorBuscaProveedor();
              }else{
                let auxilarAOC = new AuxiliarAOC();
                if(this.llamada == 1){
                  auxilarAOC.identificador = _.cloneDeep(this.representant.identificadorlegal);
                }else{
                  auxilarAOC.identificador = _.cloneDeep(null);
                  auxilarAOC.dboid = _.cloneDeep(null);
                }
                auxilarAOC.check = _.cloneDeep(this.cheklogin);
                auxilarAOC.llamada = _.cloneDeep(this.llamada);
                this.dialogRef.close(auxilarAOC);
                this.loading = false;
              }
            }else{
              this.loading = false;
              if(this.dialogsRepreAOCService.isProveidor.error != null){
                this.validService.errorCargaWS('WARNINGS.error_ws_provee');
              }else{
                let textoaviso = this.translateService.instant('WARNINGS.error_buscador_prov');
                this.textobotonperfil = this.translateService.instant('salir');
                this.textoavisoperfil = textoaviso + this.nifcheck1.bold();
                this.comprobarPerfilcheck1 = true;
              }
            }
            break;
          }
        }
      });
    }
  }

  /**
  * @description
  * Abre un cuadro de dialogo para informar de un error
  * @param error Texto a mostrar
  */
  public errorWebservice(error: string) {
    this.loading = false;
    const dialogRef = this.dialog.open(DialogsAlertComponent, {
      disableClose: true,
      hasBackdrop: true,
      data: { texto: this.translateService.instant(error) }
    });
    dialogRef.afterClosed().subscribe(result => {
      console.log(result);
    });
  }

  /**
  * @description
  * recogemo el valor del Check del cuadro de dialogo.
  */
  public handleChange() {
    if(this.cheklogin == 1){
      this.estadocombo = true;
    }else{
      this.estadocombo = false;
    }
  }

  /**
  * @description
  * Deshabilita o habilita el botón aceptar
  */
  public deshabilitar(){
    if(this.cheklogin == 1){
      return false;
    }else{
      if(Utils.noUndfAndNull(this.representant.identificadorlegal) && this.representant.identificadorlegal !== "null") {
          return false;
      }else{
        return true;
      }
    }
  }

  /**
  * @description
  * Abre un cuadro de dialogo para informar de un error en carpeta empresa
  */
  public errorvalidCiudadano() {
    let nifopcion: string;
    this.cheklogin == 1 ? nifopcion = this.nifcheck1 : nifopcion = this.dialogsRepreAOCService.nif;

    let texto1 = this.translateService.instant('WARNINGS.error_valid_ciutada');
    let texto2 = this.translateService.instant('WARNINGS.error_cif_ciut');
    let niftexto = texto1 + nifopcion.bold() + texto2;
    setTimeout(() => {
        const dialogRef = this.dialog.open(DialogsAlertComponent, {
            disableClose: true,
            hasBackdrop: true,
            data: { texto: niftexto }
        });
        dialogRef.afterClosed().subscribe(result => {
            console.log(result);
        });
    }, 500);
  }

  /**
  * @description
  * Abre un cuadro de dialogo para informar de un error en carpeta empresa
  */
  public errorBuscaCiudadano() {
    let nifopcion: string;
    this.cheklogin == 1 ? nifopcion = this.nifcheck1 : nifopcion = this.dialogsRepreAOCService.nif;

    let texto1 = this.translateService.instant('WARNINGS.error_buscador_ciu');
    let texto2 = this.translateService.instant('WARNINGS.error_tercer_ciu');
    let niftexto = texto1 + nifopcion.bold() + texto2;
    setTimeout(() => {
        const dialogRef = this.dialog.open(DialogsAlertComponent, {
            disableClose: true,
            hasBackdrop: true,
            data: { texto: niftexto }
        });
        dialogRef.afterClosed().subscribe(result => {
            console.log(result);
        });
    }, 500);
  }

  /**
  * @description
  * Abre un cuadro de dialogo para informar de un error en carpeta empresa
  */
  public errorBuscaEmpresa() {
    let nifopcion: string;
    this.cheklogin == 1 ? nifopcion = this.nifcheck1 : nifopcion = this.dialogsRepreAOCService.nif;

    let texto1 = this.translateService.instant('WARNINGS.error_buscador_emp');
    let texto2 = this.translateService.instant('WARNINGS.error_tercer_emp');
    let niftexto = texto1 + nifopcion.bold() + texto2;
    setTimeout(() => {
        const dialogRef = this.dialog.open(DialogsAlertComponent, {
            disableClose: true,
            hasBackdrop: true,
            data: { texto: niftexto }
        });
        dialogRef.afterClosed().subscribe(result => {
            console.log(result);
        });
    }, 500);
  }

  /**
  * @description
  * Abre un cuadro de dialogo para informar de un error en carpeta empresa
  */
  public errorvalidEmpresa() {
    let nifopcion: string;
    this.cheklogin == 1 ? nifopcion = this.nifcheck1 : nifopcion = this.dialogsRepreAOCService.nif;

    let texto1 = this.translateService.instant('WARNINGS.error_valid_empresa');
    let texto2 = this.translateService.instant('WARNINGS.error_cif_empr');
    let niftexto = texto1 + nifopcion.bold() + texto2;
    setTimeout(() => {
        const dialogRef = this.dialog.open(DialogsAlertComponent, {
            disableClose: true,
            hasBackdrop: true,
            data: { texto: niftexto }
        });
        dialogRef.afterClosed().subscribe(result => {
            console.log(result);
        });
    }, 500);
  }

  /**
  * @description
  * Abre un cuadro de dialogo para informar de un error en carpeta empresa
  */
  public errorBuscaProveedor() {
    let nifopcion: string;
    this.cheklogin == 1 ? nifopcion = this.nifcheck1 : nifopcion = this.dialogsRepreAOCService.nif;

    let texto1 = this.translateService.instant('WARNINGS.error_buscador_prov');
    let texto2 = this.translateService.instant('WARNINGS.error_cif_prov');
    let niftexto = texto1 + nifopcion.bold() + texto2;
    setTimeout(() => {
        const dialogRef = this.dialog.open(DialogsAlertComponent, {
            disableClose: true,
            hasBackdrop: true,
            data: { texto: niftexto }
        });
        dialogRef.afterClosed().subscribe(result => {
            console.log(result);
        });
    }, 500);
  }

  /**
  * @description
  * Si un usuario no tiene acceso al rol de carpeta; se le redirige a los demás roles
  */
  public llamadacarpeta(){
    console.log("estas llamando a carpeta desde un boton");
    let auxilarAOC = new AuxiliarAOC();
    switch(this.carpeta) {
      case "1": {
        auxilarAOC.carpeta = EXTERNAL_ROL.PAGES.empresa;
        this.dialogsRepreAOCService.filtroCarpeta(this.nifcheck1, this.carpeta).subscribe(result => {
          this.allRepresentantsPerfil = _.cloneDeep(result);

          if(this.cheklogin == 2){
            auxilarAOC.identificador = _.cloneDeep(this.representant.identificadorlegal);
            auxilarAOC.check = _.cloneDeep(this.cheklogin);
            auxilarAOC.dboid = _.cloneDeep(this.dialogsRepreAOCService.dboidRepresentado);
            auxilarAOC.llamada = _.cloneDeep(this.llamada);
            this.dialogRef.close(auxilarAOC);
          }else{
            if(this.llamada == 1){
              auxilarAOC.identificador = _.cloneDeep(this.representant.identificadorlegal);
              auxilarAOC.representantsAOC = _.cloneDeep(this.allRepresentantsPerfil);
            }else{
              auxilarAOC.identificador = _.cloneDeep(null);
              auxilarAOC.dboid = _.cloneDeep(null);
            }
            auxilarAOC.check = _.cloneDeep(this.cheklogin);
            auxilarAOC.llamada = _.cloneDeep(this.llamada);
            this.dialogRef.close(auxilarAOC);
          }
          
        });
        break;
      }
      case "2": {
        auxilarAOC.carpeta = EXTERNAL_ROL.PAGES.ciudadano;
        this.dialogsRepreAOCService.filtroCarpeta(this.nifcheck1, this.carpeta).subscribe(result => {
          this.allRepresentantsPerfil = _.cloneDeep(result);

          if(this.cheklogin == 2){
            auxilarAOC.identificador = _.cloneDeep(this.representant.identificadorlegal);
            auxilarAOC.check = _.cloneDeep(this.cheklogin);
            auxilarAOC.dboid = _.cloneDeep(this.dialogsRepreAOCService.dboidRepresentado);
            auxilarAOC.llamada = _.cloneDeep(this.llamada);
            this.dialogRef.close(auxilarAOC);
          }else{
            if(this.llamada == 1){
              auxilarAOC.identificador = _.cloneDeep(this.representant.identificadorlegal);
            }else{
              auxilarAOC.identificador = _.cloneDeep(null);
              auxilarAOC.dboid = _.cloneDeep(null);
            }
            auxilarAOC.representantsAOC = _.cloneDeep(this.allRepresentantsPerfil);
            auxilarAOC.check = _.cloneDeep(this.cheklogin);
            auxilarAOC.llamada = _.cloneDeep(this.llamada);
            this.dialogRef.close(auxilarAOC);
          }
        });
        break;
      }
      case "3": {
        this.dialogRef.close(undefined);
        break;
      }
    }
  }

}
